import { useCallback } from 'react';

import { useRole } from '@/hooks/use-role';
import { useScope } from '@/hooks/use-scope';

export function useUrlPrefix() {
  const role = useRole();
  const { organizationSlug } = useScope();

  const decorateUrl = useCallback(
    (url: string) => {
      const path = url.startsWith('/') ? url.slice(1) : url;
      if (role) {
        if (role === 'tenant') {
          return `/tenant/${path}`;
        } else if (role === 'org') {
          return `/org/${organizationSlug}/${path}`;
        }
      }

      return url;
    },
    [role, organizationSlug],
  );

  return decorateUrl;
}
